import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";

const DownloadBrochures = () => {
    const [activeTab, setActiveTab] = useState("english");

    const brochures = {
        english: [
            {
                title: "Arogyavardhan Health Plan",
                file: "assets/brochures/Arogyavardhan-Health-Plan-English.pdf",
            },
            {
                title: "Aushadhi Health Plan",
                file: "assets/brochures/Aushadhi-Health-Plan-English.pdf",
            },
            {
                title: "Ayush Health Plan",
                file: "assets/brochures/Ayush-Health-Plan-English.pdf",
            },
            {
                title: "Niyog Health Plan",
                file: "assets/brochures/Niyog-Health-Plan-English.pdf",
            },
            {
                title: "Prakriti Health Plan",
                file: "assets/brochures/Prakriti-Health-Plan-English.pdf",
            },
            {
                title: "Proposal Form",
                file: "assets/brochures/Praposal-Form.pdf",
            },
        ],
        hindi: [
            {
                title: "आरोग्यवर्धन स्वास्थ्य योजना",
                file: "assets/brochures/Arogyavardhan-Health-Plan-Hindi.pdf",
            },
            {
                title: "औषधि स्वास्थ्य योजना",
                file: "assets/brochures/Aushadhi-Health-Plan-Hindi.pdf",
            },
            {
                title: "आयुष स्वास्थ्य योजना",
                file: "assets/brochures/Ayush-Health-Plan-Hindi.pdf",
            },
            {
                title: "नियोग स्वास्थ्य योजना",
                file: "assets/brochures/Niyog-Health-Plan-Hindi.pdf",
            },
            {
                title: "प्रकृति स्वास्थ्य योजना",
                file: "assets/brochures/Prakriti-Health-Plan-Hindi.pdf",
            },
        ],
    };


    return (
        <>
            {/* BANNER SECTION (unchanged) */}
            <section className="pt-[180px] max-md:pt-[130px] pb-[80px] relative bg-[#f4f4f4] about-banner overflow-hidden">
                <div className="container">
                    <div className="row items-center">
                        <div className="w-full">
                            <div className="relative max-md:text-center">
                                <h2 className="text-[92px] max-md:text-[50px] font-bold font-sora text-secondary leading-[1.2]">
                                    Download Brochures
                                </h2>
                                <img
                                    src="assets/img/shap-three-1.png"
                                    alt="banner-shap"
                                    className="absolute -top-[30px] -left-[32px] max-md:hidden w-[50px] animate-topshap"
                                />
                            </div>

                            <ol className="mb-[16px] flex items-center pt-[20px] max-md:hidden">
                                <li className="text-[22px] text-secondary font-sora">
                                    <Link to="/">Home</Link>
                                </li>
                                <li className="text-[22px] text-gary before:content-['-'] before:px-[10px]">
                                    Downloads
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            {/* CONTENT SECTION */}
            <section className="relative w-full overflow-hidden">
                <div className="w-full pb-[80px] pt-[80px]">
                    <div className="container">
                        <div className="services-details-items">
                            <div className="row">
                                <div className="col-xl-12 w-full services-single-content">

                                    {/* 🔥 PILL TABS WITH ANIMATED UNDERLINE */}
                                    <div className="inline-flex relative bg-white rounded-full p-1 shadow-sm border">
                                        {["english", "hindi"].map((tab) => (
                                            <button
                                                key={tab}
                                                onClick={() => setActiveTab(tab)}
                                                className={`relative z-10 px-6 py-2 text-sm font-medium rounded-full transition-colors
                          ${activeTab === tab
                                                        ? "text-white"
                                                        : "text-gray-600 hover:text-[#1f87c9]"
                                                    }`}
                                            >
                                                {tab === "english" ? "English" : "हिंदी"}

                                                {/* Animated Pill */}
                                                {activeTab === tab && (
                                                    <motion.span
                                                        layoutId="active-pill"
                                                        className="absolute inset-0 bg-[#1f87c9] rounded-full -z-10"
                                                        transition={{
                                                            type: "spring",
                                                            stiffness: 500,
                                                            damping: 30,
                                                        }}
                                                    />
                                                )}
                                            </button>
                                        ))}
                                    </div>

                                    {/* 🔥 TAB CONTENT WITH SMOOTH TRANSITION */}
                                    <div className="mt-8 min-h-[200px]">
                                        <AnimatePresence mode="wait">
                                            <motion.div
                                                key={activeTab}
                                                initial={{ opacity: 0, y: 10 }}
                                                animate={{ opacity: 1, y: 0 }}
                                                exit={{ opacity: 0, y: -10 }}
                                                transition={{ duration: 0.3 }}
                                                className="grid md:grid-cols-6 gap-6"
                                            >
                                                {brochures[activeTab].map((item, index) => (
                                                    <motion.div
                                                        key={item.title}
                                                        initial={{ opacity: 0, y: 15 }}
                                                        animate={{ opacity: 1, y: 0 }}
                                                        transition={{ delay: index * 0.08 }}
                                                        className="bg-white col-span-3 rounded-xl border shadow-sm p-5 flex items-center justify-between hover:shadow-md transition-shadow max-md:block"
                                                    >
                                                        {/* Left: Title */}
                                                        <div>
                                                            <h4 className="text-base font-semibold text-secondary">
                                                                {item.title}
                                                            </h4>
                                                            <p className="text-xs text-gray-500 mt-1">PDF Document</p>
                                                        </div>

                                                        {/* Right: Download Button */}
                                                        <a
                                                            href={item.file}
                                                            target="new"
                                                            className="inline-flex items-center gap-2 text-sm font-medium text-white bg-[#1f87c9] px-4 py-2 rounded-lg hover:bg-[#176fa3] transition-colors max-md:mt-4"
                                                        >
                                                            View PDF
                                                            <svg
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                className="w-4 h-4"
                                                                fill="none"
                                                                viewBox="0 0 24 24"
                                                                stroke="currentColor"
                                                                strokeWidth={2}
                                                            >
                                                                <path
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                    d="M12 4v12m0 0l-4-4m4 4l4-4M4 20h16"
                                                                />
                                                            </svg>
                                                        </a>
                                                    </motion.div>
                                                ))}
                                            </motion.div>
                                        </AnimatePresence>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default DownloadBrochures;
